/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  Button,
} from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import styles from './styles/main.scss';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import CSSModules from 'react-css-modules';
import successImg from './images/check.svg';

class RegistSuccess extends React.Component {

  constructor(props) {
    super(props);
    this.gotoLogin = this.gotoLogin.bind(this);
  }

  intlMsg(id, ns) {
    ns = ns || 'newRegisterSuccess';
    return this.props.intl.formatMessage({
      id: `${ns}.${id}`,
      defaultMessage: `${ns}.${id}`,
    });
  }

  gotoLogin() {
    this.props.pushState('/login');
  }

  render() {
    return (
      <div styleName="wrapper">
        <div styleName="regres">
          <div styleName="regres-body">
            <h1>
              <span styleName="regres-img">
                <img src={successImg} className="img-responsive" alt="" />
              </span>
              {this.intlMsg('h1')}
            </h1>
            <Button bsStyle="aisz-primary" onClick={this.gotoLogin}>
              {this.intlMsg('loginbtn')}
              {' '}
              <i className="fa fa-sign-in" aria-hidden="true" />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(() => ({}), {
  pushState: routerActions.push,
})(injectIntl(CSSModules(RegistSuccess, styles, { allowMultiple: true })));;




// WEBPACK FOOTER //
// ./src/containers/User/RegistSuccess/index.jsx